module.exports = __webpack_public_path__ + "img/second-floor.ab3aa09b.jpg";